import { apiConfig } from "@integrations/APIIntegration";
import { Logger } from "@utils/Logger";

let env = process.env.REACT_APP_FRONT_ENV || 'PROD';
let analyticsEnv = process.env.ANALYTICS_ENV ?? env

class URLs {
    static qa = "https://qa-analytics.qeeptouch.com" 
    static prod = "https://analytics.qeeptouch.com"
    static local = "http://localhost:8081"
}

let analyticsBaseURL
switch (analyticsEnv) {
    case "PROD":
        analyticsBaseURL = URLs.prod
        break
    case "LOCAL":
        analyticsBaseURL = URLs.local
        break
    default:
        analyticsBaseURL = URLs.qa
}

Logger.log("analytics env", analyticsEnv)
Logger.log("analytics env", analyticsBaseURL)

export namespace SystemURL {
    export enum HourBankCompensation {
        getPendingRequests = "/api/hour-bank-compensation/pending-requests/organization/:org_id", // Requests.VIEW
        getProcessedRequests = "/api/hour-bank-compensation/processed-requests/organization/:org_id", // Requests.VIEW
        postApproveRequest = "/api/hour-bank-compensation/flow-token/:flow_token/approve", // Requests.DECIDE
        postRejectRequest = "/api/hour-bank-compensation/flow-token/:flow_token/reject", // Requests.DECIDE
    }
    export enum LeaveAbsense {
        getPendingRequests = "/api/leave-absense/pending-requests/organization/:org_id",     // Requests.VIEW
        getProcessedRequests = "/api/leave-absense/processed-requests/organization/:org_id", // Requests.VIEW
        postApproveRequest = "/api/leave-absense/flow-token/:flow_token/approve",  // Requests.DECIDE
        postRejectRequest = "/api/leave-absense/flow-token/:flow_token/reject",   // Requests.DECIDE
    }
    export enum Questions {
    getInbox = "/api/questions/organization/:org_id/inbox",
    getRead = "/api/questions/organization/:org_id/read",
    getResponded = "/api/questions/organization/:org_id/responded",
    getArchived = "/api/questions/organization/:org_id/archived",
    postMarkAsRead = "/api/questions/:question_id/mark-as-read",
    postArchive = "/api/questions/:question_id/archive",
    postUnarchive = "/api/questions/:question_id/unarchive",
    postRespond = "/api/questions/:question_id/respond",
    }
    export enum Novedades {
        postCloseRfi = "/api/novedades/rfi/presenteeism-check/close/:id",  // Novelties.MANAGE_ABSENTS
        getInasistenciasPaginated = "/api/novedades/rfi/presenteeism-check/:org_id?pageSize=:pageSize&lastKey=:lastKey", //Novelties.VIEW_ABSENTS
        updateNovedadData = "/api/novedades/rfi/presenteeism-check/resolve/:org_id/:row_id", // Novelties.MANAGE_ABSENTS
        postStatusPresenteeismCheckResolve = "/api/novedades/status/presenteeism-check/resolve/:org_id/:date",  // Novelties.MANAGE
        postStatusPresenteeismCheckResolveBulk = "/api/novedades/status/presenteeism-check/resolveBulk/:org_id", // Novelties.MANAGE
        getReporte = "/api/novedades/reporte/:org_id", // Novelties.VIEW
        getNovedades = "/api/novedades/:org_id", // Novelties.VIEW
        getAudit = "/api/novedades/audit/:org_id", // Novelties.VIEW
        postCreateNovedad = "/api/novedades/:org_id", // Novelties.CONFIG
        postDisableNovedad = "/api/novedades/disableNovedad/:org_id", // Novelties.CONFIG
        postLicenseEnabledNovedad = "/api/novedades/licenses/:org_id", // Novelties.CONFIG
        getConfigurationDias = "/api/novedades/dias/:org_id", // Novelties.VIEW
        postConfigurationDias = "/api/novedades/dias/:org_id", // Novelties.CONFIG
        getConfigurationFeriados = "/api/novedades/feriados/:org_id", // Novelties.VIEW
        postConfigurationFeriados = "/api/novedades/feriados/:org_id", // Novelties.CONFIG
    }
    export enum NovedadesExport {
        postProcess = "/api/novedades-export/processes",
        getProcesses = "/api/novedades-export/organizations/:organization_id/processes",
        getProfiles = "/api/novedades-export/organizations/:organization_id/profiles",
        getWorkedHoursCalculationProfiles = "/api/novedades-export/organizations/:organization_id/worked-hours-calculation-profiles",
        getWorkedHoursCalculationConfiguration = "/api/novedades-export/organizations/:organization_id/worked-hours-calculation-configuration",
        putWorkedHoursCalculationConfiguration = "/api/novedades-export/organizations/:organization_id/worked-hours-calculation-configuration",
        getStatusMappingConfiguration = "/api/novedades-export/organizations/:organization_id/status-mapping-configuration",
        putStatusMappingConfiguration = "/api/novedades-export/organizations/:organization_id/status-mapping-configuration",
        getColppyConfiguration = "/api/novedades-export/organizations/:organization_id/colppy-configuration",
        putColppyConfiguration = "/api/novedades-export/organizations/:organization_id/colppy-configuration",
        getProcess = "/api/novedades-export/processes/:process_id",
        postRestartProcess = "/api/novedades-export/processes/:process_id/restart",
        postGenerateExportRows = "/api/novedades-export/processes/:process_id/export-rows/generate",
        postGenerateExportFile = "/api/novedades-export/processes/:process_id/file/generate",
        getExportRows = "/api/novedades-export/processes/:process_id/export-rows",
        getEvents = "/api/novedades-export/processes/:process_id/events",
        getEmployees = "/api/novedades-export/processes/:process_id/employees",
    }
    export enum QontactPoints {
        getCommunicationChannel = "/api/admin/communication-channel/organization/:org_id", // check-in channel (decides which QR to show)
        getPresenteeismResumen = "/api/dashboards/organization/:org_id/building/:bu_id/presenteeism-summary", // QontactPoints.VIEW
        getPaginated = "/api/dashboards/qontactPoint/organization/:org_id?pageSize=:pageSize&lastKey=:lastKey", // QontactPoints.VIEW
        getById = "/api/dashboards/qontactPoint/:qontactPoint_id", // QontactPoints.VIEW
        postCreate = "/api/dashboards/qontactPoint/:org_id", // QontactPoints.MANAGE
        putUpdate = "/api/dashboards/qontactPoint/:building_id", // QontactPoints.MANAGE
        deleteQontactPoint = "/api/dashboards/qontactPoint/:qontactPoint_id", // QontactPoints.MANAGE
        getCustomFields = "/api/dashboards/qontactPoint/organization/:org_id/custom-fields", // QontactPoints.VIEW
        postCustomField = "/api/dashboards/qontactPoint/organization/:org_id/custom-fields", // QontactPoints.MANAGE
        patchCustomField = "/api/dashboards/qontactPoint/organization/:org_id/custom-fields/:field_id", // QontactPoints.MANAGE
        deleteCustomField = "/api/dashboards/qontactPoint/organization/:org_id/custom-fields/:field_id", // QontactPoints.MANAGE
        getCustomFieldValues = "/api/dashboards/qontactPoint/organization/:org_id/qontactPoint/:qp_id/custom-field-values", // QontactPoints.VIEW
        patchCustomFieldValues = "/api/dashboards/qontactPoint/organization/:org_id/qontactPoint/:qp_id/custom-field-values", // QontactPoints.MANAGE
        putTriggerDistance = "/api/dashboards/qontactPoint/organization/:org_id/qontactPoint/:qp_id/trigger-distance", // QontactPoints.MANAGE
        getDefaultTriggerDistance = "/api/dashboards/qontactPoint/organization/:org_id/default-trigger-distance", // QontactPoints.VIEW
    }
    export enum Alerts {
        getForOrg = "/api/dashboards/alerts/organization/:organization_id", // Alerts.VIEW
        getForOrgDay = "/api/dashboards/alerts/organization/:organization_id/day/:day", // Alerts.VIEW
        getForOrgDayTable = "/api/dashboards/alerts/organization/:organization_id/day/:day/table", // Alerts.VIEW
        getDetail = "/api/dashboards/alerts/organization/:organization_id/alert/:alert_id/detail", // Alerts.VIEW
        getOrgSubscriptions = "/api/dashboards/alerts/subscription/organization/:organization_id", // Alerts.VIEW
        postAddOrgSubscription = "/api/dashboards/alerts/subscription/organization/:organization_id", // Alerts.MANAGE
        deleteRemoveOrgSubscription = "/api/dashboards/alerts/subscription/organization/:organization_id", // Alerts.MANAGE
        getBuildingSubscriptions = "/api/dashboards/alerts/subscription/organization/:organization_id/building/:building_id", // Alerts.VIEW
        postAddBuildingSubscription = "/api/dashboards/alerts/subscription/organization/:organization_id/building/:building_id", // Alerts.MANAGE
        deleteRemoveBuildingSubscription = "/api/dashboards/alerts/subscription/organization/:organization_id/building/:building_id", // Alerts.MANAGE
    }
    export enum Users {
        postUser = "/api/users/",
        postCreateUser = "/api/users/organization/:org_id/user", //Collaborators.MANAGE
        postUploadPhoto = "/api/users/:user_id/:org_id/photo", //Collaborators.MANAGE
        postEdit = "/api/users/organization/:org_id/user/:user_id/edit", //Collaborators.MANAGE
        getCustomFields = "/api/users/organization/:org_id/custom-fields", //Collaborators.MANAGE
        postCustomField = "/api/users/organization/:org_id/custom-fields", //Collaborators.MANAGE
        patchCustomField = "/api/users/organization/:org_id/custom-fields/:field_id", //Collaborators.MANAGE
        deleteCustomField = "/api/users/organization/:org_id/custom-fields/:field_id", //Collaborators.MANAGE

        postReactivate = "/api/users/reactivate/org/:org_id/user/:user_id", //Collaborators.MANAGE
        postDeactivate = "/api/users/deactivate/org/:org_id/user/:user_id", //Collaborators.MANAGE

        getDocuments = "/api/users/:user_id/:org_id/document", //Collaborators.DOCS_VIEW
        postGenerateUploadUrl = "/api/users/:user_id/generate-upload-url", //Collaborators.DOCS_MANAGE
        postLinkDocument = "/api/users/:user_id/:org_id/link-document", //Collaborators.DOCS_MANAGE
        getDownloadDocument = "/api/users/:user_id/downloadDocument?url=:fileUrl", //Collaborators.DOCS_VIEW
        deleteDocument = "/api/users/:user_id/:org_id/document", //Collaborators.DOCS_MANAGE

        getNomina = "/api/users/organization/:org_id/user", //Collaborators.VIEW
        searchUsers = "/api/users/search/organization/:org_id/users?query=:query&page=:page&hitsPerPage=:hitsPerPage", //Collaborators.VIEW | Collaborators.MANUAL_RECORD
        getWhatsappPresenteeismTable = "/api/users/user/:phone/presenteeismTable/:org_id", //Collaborators.VIEW

        postCreateAdminUser = "/api/users/admin/:org_id", // Admin.CONFIG_DASHBOARD_USERS
        getAdminUsers = "/api/users/search/organization/:org_id/users/*", // Admin.CONFIG_DASHBOARD_USERS
        deactivateAdminUser = "/api/users/admin/:org_id/user/:user_id", // Admin.CONFIG_DASHBOARD_USERS
    }
    export enum Shifts {
        getRecipe = "/api/shifts/organization/:org_id/recipe/:recipe_id", // Shifts.VIEW
        getRecipesForFunctionalUnit = "/api/shifts/organization/:org_id/functionalUnit/:functional_unit_id/recipes", // Shifts.VIEW
        postCreateRecipe = "/api/shifts/organization/:org_id/recipes", // Shifts.MANAGE
        postUpdateRecipe = "/api/shifts/organization/:org_id/recipe/:recipe_id", // Shifts.MANAGE
        deleteRecipe = "/api/shifts/organization/:org_id/recipe/:recipe_id", // Shifts.MANAGE
        postV1ConfigUpdate = "/api/admin/shifts/organization/:org_id/building/:building_id", //Shifts.MANAGE
    }
    export enum UserDedicatedShifts {
        getRecipes = "/api/dedicated-shifts/organization/:org_id/user/:user_id/recipes", // Collaborators.MANAGE
        postCreateRecipe = "/api/dedicated-shifts/organization/:org_id/user/:user_id/recipes", // Collaborators.MANAGE
        postUpdateRecipe = "/api/dedicated-shifts/organization/:org_id/user/:user_id/recipe/:recipe_id", // Collaborators.MANAGE
        deleteRecipe = "/api/dedicated-shifts/organization/:org_id/user/:user_id/recipe/:recipe_id", // Collaborators.MANAGE
    }
    export enum Communications {
        getCommunication = "/api/communications/organization/:org_id", // Communications.MANAGE
        postCreate = "/api/communications/organization/:org_id", // Communications.MANAGE
        deleteCommunication = "/api/communications/organization/:org_id", // Communications.MANAGE
    }
    export enum Notifications {
        getNotifications = "/api/dashboards/notifications/organization/:org_id?pageSize=:pageSize&lastKey=:lastKey", // Notifications.VIEW
        getLastReadTimestamp = "/api/dashboards/notifications/organization/:org_id/lastReadTimestamp", // Notifications.VIEW
        postLastReadTimestamp = "/api/dashboards/notifications/organization/:org_id/lastReadTimestamp", // Notifications.MANAGE
    }
    export enum SecondFactorAuthentication {
        getPolicy = "/api/admin/presenteeism-2fa/organization/:org_id/policy",
        putMode = "/api/admin/presenteeism-2fa/organization/:org_id/policy/mode",
        putSubject = "/api/admin/presenteeism-2fa/organization/:org_id/policy/subjects/:subject_id",
        getDevices = "/api/admin/presenteeism-2fa/organization/:org_id/devices",
        putDeactivateDevice = "/api/admin/presenteeism-2fa/organization/:org_id/devices/:device_installation_id/deactivate",
        postInstallInvitations = "/api/auth-app-install/invitations",
    }
    export enum Dashboard {
        getOrganizationsPaginated = "/api/users/:uid/organizationsWithNewFlags?pageSize=:pageSize&lastKey=:lastKey",
        getUserRoleInOrganization = "/api/dashboards/user-role/organization/:org_id/user/:user_id",
        getBuildingsWithQps = "/api/organizations/:org_id/buildingsWithQPs", // Admin.VIEW_PRESENTEEISM
        getBuildingsWithQpsPaginated = "/api/organizations/:org_id/buildingsWithQPs/paginated?pageSize=:pageSize&lastKey=:lastKey", // Admin.VIEW_PRESENTEEISM
        getUserCount = "/api/users/count/:org_id", // Admin.VIEW_PRESENTEEISM
        getPresenteeismTableRange = "/api/dashboards/presenteeismTable/organization/:org_id/:startDate/:endDate", // Admin.VIEW_PRESENTEEISM
        getPresenteeismTableDay = "/api/dashboards/presenteeismTable/organization/:org_id/day/:processedDate", // Admin.VIEW_PRESENTEEISM
        getKioskRecordEvidence = "/api/presenteeism/kiosk-record/:record_id/evidence", // Admin.VIEW_PRESENTEEISM
        getPresenteeismShiftsDay = "/api/dashboards/presenteeismShifts/organization/:org_id/day/:processedDate", // Admin.VIEW_PRESENTEEISM
        postManualRecord = "/api/presenteeism/manual-record", // Collaborators.MANUAL_RECORD
        getHourBankSummary = "/api/dashboards/hourBank/organization/:org_id/summary", // Admin.VIEW_PRESENTEEISM
        getHourBankSummaryDateRange = "/api/dashboards/hourBank/organization/:org_id/summary/:startDate/:endDate", // Admin.VIEW_PRESENTEEISM
        getHourBankCollaboratorEntries = "/api/dashboards/hourBank/organization/:org_id/collaborator/:collaborator_id/entries", // Admin.VIEW_PRESENTEEISM
        postHourBankCollaboratorEntry = "/api/dashboards/hourBank/organization/:org_id/collaborator/:collaborator_id/entries", // Collaborators.MANAGE
    }
    export enum Presenteeism {
        getFailureAttempts = "/api/presenteeism/organization/:org_id/failure-attempts", // Admin.VIEW_PRESENTEEISM
        getConciliationDetail = "/api/presenteeism/conciliation-detail", // Admin.VIEW_PRESENTEEISM
        getPendingCheckoutDetail = "/api/presenteeism/pending-checkout-detail", // Admin.VIEW_PRESENTEEISM
        postConciliationCancelation = "/api/presenteeism/conciliation-cancelation", // Collaborators.MANUAL_RECORD
        postConciliationCancelationUndo = "/api/presenteeism/conciliation-cancelation-undo", // Collaborators.MANUAL_RECORD
    }
    export enum Roster {
        getRosterForDay = "/api/dashboards/roster/organization/:org_id/day/:day", // Admin.VIEW_PRESENTEEISM
        getRosterByQontactPointForDay = "/api/dashboards/roster/organization/:org_id/day/:day/qontact-points", // Admin.VIEW_PRESENTEEISM
    }
    export enum Metabase {
        getToken = "/api/metabase/token?questionCode=:questionCode&type=:type", // Reports.VIEW
        getOrganizationReports = "/api/metabase/organization/:org_id", // Reports.VIEW
    }

    export enum Roles {
        getRoles = '/api/roles/:org_id', // Admin.CONFIG_ROLES
        postCreateRole = '/api/roles/:org_id', // Admin.CONFIG_ROLES
        putUpdateRolePermissions = '/api/roles/:org_id/:role_id/permissions', // Admin.CONFIG_ROLES
        deleteRole = '/api/roles/:org_id/:role_id', // Admin.CONFIG_ROLES
        postAssignRoleToUser = '/api/roles/:org_id/:role_id/assign/:user_id', // Admin.CONFIG_ROLES
        deleteUnassignRoleFromUser = '/api/roles/:org_id/:role_id/assign/:user_id', // Admin.CONFIG_ROLES
        getUserRoleAssignment = '/api/roles/:org_id/user/:user_id/assignment', // Admin.CONFIG_ROLES
        getAllAssignments = '/api/roles/:org_id/assignments', // Admin.CONFIG_ROLES
    }

    export enum Analytics {
        postEvent = "/api/analytics/event"
    }

    export enum Algolia {
        getSearchQontactPoints = "/api/dashboards/qontactPoint/organization/:org_id/search?query=:query&page=:number&hitsPerPage=:hits_per_page", // QontactPoints.VIEW
        getSearchQontactPointsV2 = "/api/dashboards/qontactPoint/organization/:org_id/searchV2?query=:query&page=:number&hitsPerPage=:hits_per_page", // QontactPoints.VIEW
    }

    export enum Audit {
        getAuditLogs = "/api/users/audit/org/:org_id/collaborator/:colab_id",
    }

    // App adoption ("Adopción de la app"): who installed the Qontact Auth app, plus
    // WhatsApp install invitations. The POST carries the organization in the body —
    // that backend route predates the path-variable convention.
    export enum AuthAppInstall {
        getCollaborators = "/api/auth-app-install/organizations/:organization_id/collaborators",
        postInvitations = "/api/auth-app-install/invitations",
    }

    export enum Onboarding {
        getPilots = "/api/onboarding/pilots",
        postCreatePilot = "/api/onboarding/pilot/:org_id",
        postPilotStartUserCountry = "/api/onboarding/pilot/user/country/:country_code",
        postConvertPilotOrganization = "/api/onboarding/pilot/:org_id/convert",
        patchUpdatePilotOrganization = "/api/onboarding/pilot/:org_id",
        postDeprecatePilotOrganization = "/api/organization/:org_id/deprecate",
    }
}

function getBaseURL(template: string): string {
    switch (template) {
        case SystemURL.Analytics.postEvent:
            return analyticsBaseURL
        default:
            return apiConfig.baseURL
    }
}

export const buildURL = (urlTemplate: string, variables: Record<string, string>): string => {
    const url = urlTemplate.replace(/:([A-Za-z0-9_]+)/g, (_, key: string) => {
        if (!(key in variables)) {
            throw new Error(`buildURL: missing value for ":${key}"`);
        }
        return encodeURIComponent(variables[key]);
    });

    switch (urlTemplate) {

    }

    return `${getBaseURL(urlTemplate)}${url}`;
};
